import {EmailCustomerAction} from "./components/action_components/actions/email_action/EmailCustomerAction";
import {OpportunitiesActionsLog} from "./components/opportunities-actions-log/OpportunitiesActionsLog";
import {EmailAgentAction} from "./components/action_components/actions/email_agent_action/EmailAgentAction";
import {OpportunityModule} from "./OpportunityActionsModuleConfiguration";
import {SendLetterAction} from "./components/action_components/actions/send_physical_letter_action/SendLetterAction";
import {SendSmsAction} from "./components/action_components/actions/send_sms_action/SendSmsAction";
import {OpportunityPreRenderService} from "./service/OpportunityPreRenderService";
import {OpportunityPreRenderServiceName} from "../utils/names/serviceNames";

OpportunityModule
    .createNewModule()
    .component('emailAction', EmailCustomerAction.instance())
    .component('emailAgentAction', EmailAgentAction.instance())
    .component('sendLetterAction', SendLetterAction.instance())
    .component('sendSmsAction', SendSmsAction.instance())
    .component('actionsLog', OpportunitiesActionsLog.instance)
    .service(OpportunityPreRenderServiceName, OpportunityPreRenderService.instance);